/* eslint-disable react/no-unstable-nested-components */
import { ColumnDef } from '@tanstack/react-table';
import ApiCard, { ApiCardData } from 'components/apiCard';
import { TableWrapperProps } from 'models/general';
import { useMemo } from 'react';
import LegacyTableBase from './base/legacyTableBase';
import { TableModifier } from './base/tableBase';
import { TableBaseApiKind } from './base/tableBaseApi';

export interface ApiTableDef {
  data: ApiCardData;
}

function ApiTable(props: TableWrapperProps) {
  const { pageSize = 2 } = props;

  const apiTableColumns: ColumnDef<ApiTableDef>[] = useMemo(() => [
    {
      accessorKey: 'data',
      cell: (info) => {
        const data = info.getValue<ApiCardData>();
        return (<ApiCard data={data} />);
      },
      header: '',
    },
  ], []);

  return (
    <LegacyTableBase
      requestUri="apiTableData"
      columns={apiTableColumns}
      apiKind={TableBaseApiKind.LAMINAS}
      modifier={TableModifier.API_TABLE}
      pageSize={pageSize}
      hideMobileTable
      hideHeader
      mockData
    />
  );
}

export default ApiTable;
